export default "__VITE_ASSET__BaakNT8X__"